import { render, staticRenderFns } from "./QuizForm.vue?vue&type=template&id=038e416b&scoped=true&"
import script from "./QuizForm.vue?vue&type=script&lang=ts&"
export * from "./QuizForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuizForm.vue?vue&type=style&index=0&id=038e416b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e416b",
  null
  
)

export default component.exports